import jwt from "jsonwebtoken";
import { checkResponse } from "../utils/checkResponse";
import {
  APIKey,
  Authorization,
  Channel,
  DomainAPI,
  SecretApiKey,
  SecretApiKeyExpires,
} from "../utils/setting";

const pluginServices = {
  state: {
    listPlugins: [],
  },
  reducers: {
    setState(state, payload) {
      state = { ...state, ...payload };
      return { ...state };
    },
  },
  effects: (dispatch) => ({
    async create(payload, rootState) {
      let url = DomainAPI + Channel + "/api/secure/pluginServices/create";
      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);

      return fetch(url, {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify(payload),
      })
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          dispatch.pluginServices.getPluginsForSpa();
          return result;
        })
        .catch((error) => {
          return { code: 0, error: error, message: error.toString() };
        });
    },
    async remove(payload, rootState) {
      let url = DomainAPI + Channel + "/api/secure/pluginServices/remove";
      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);
      return fetch(url, {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify(payload),
      })
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          dispatch.pluginServices.getPluginsForSpa();
          return result;
        })
        .catch((error) => {
          return { code: 0, error: error, message: error.toString() };
        });
    },
    async getPluginsForSpa(payload, rootState) {
      const _this = this;
      let url =
        DomainAPI + Channel + "/api/secure/pluginServices/getPluginsForSpa";
      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);

      return fetch(url, {
        method: "GET",
        headers: myHeaders,
        body: JSON.stringify(payload),
      })
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          if (result.data.plugins.length === 0)
            _this.setState({ listPlugins: [{}] });
          // Để bik khi nào API này load xong
          else _this.setState({ listPlugins: result.data.plugins });
          return result;
        })
        .catch((error) => {
          return { code: 0, error: error, message: error.toString() };
        });
    },
  }),
};

export default pluginServices;
